<template>
  <div>
    <search-agency-withdrawals @submit="submitSearch" />
    <div class="iotplt-table-operation-buttons">
      <a-space>
        <a-button type="primary" @click="exportData">导出</a-button>
      </a-space>
    </div>

    <a-table
      size="middle"
      :columns="columns"
      :data-source="data"
      :loading="loading"
      :pagination="false"
      row-key="id"
    >
      <img
        slot="payorderpic"
        slot-scope="text, record"
        v-if="record.pay_order_url"
        :src="record.pay_order_url"
        style="width:50px;"
        alt=""
        @click="handlePreview(record.pay_order_url)"
      >

      <span slot="status" slot-scope="text, record">
        <span :class="'status-' + record.status_raw">{{ record.status }}</span>
      </span>

      <span slot="remark" slot-scope="text, record">
        <span :class="'remark-' + record.status_raw">{{ record.remark }}</span>
      </span>
    </a-table>

    <pagination
      v-show="pagination.total_count > 0"
      :total-count="pagination.total_count"
      :page.sync="query.page"
      :per-page.sync="query.per_page"
      @change="fetchData"
    />

    <preview-image
      :visible.sync="previewVisible"
      :image.sync="previewImage"
    />
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import SearchAgencyWithdrawals from '@/views/withdrawals/top_agent_view_agency/Search'
import { findAgentWithdrawals, exportAgentWithdrawals } from '@/api/withdrawal'
import { formatCurrency } from '@/utils/filter'
import { exportExcel } from '@/api/excel'
import PreviewImage from '@/components/PreviewImage'

export default {
  name: 'TopAgentViewAgencyWithdrawalList',
  components: {
    SearchAgencyWithdrawals,
    Pagination,
    PreviewImage
  },
  data() {
    return {
      data: [],
      loading: true,
      previewVisible: false,
      previewImage: '',
      pagination: {
        total_count: 0
      },
      query: {
      }
    }
  },
  computed: {
    agentId() {
      if (this.$route.query.agent_id) {
        return parseInt(this.$route.query.agent_id)
      }

      return parseInt(this.$route.params.id)
    },
    agentType() {
      return parseInt(this.$store.getters.userAgentType)
    },
    columns() {
      return [
        {
          title: '事件批次',
          width: 100,
          dataIndex: 'no'
        },
        {
          title: '金额(元)',
          width: 100,
          customRender: formatCurrency,
          dataIndex: 'amount'
        },
        {
          title: '支付方式',
          width: 100,
          dataIndex: 'pay_way'
        },
        {
          title: '打款信息',
          width: 300,
          customRender: (record, index) => {
            return `${record.account_name} ${record.bank_name} ${record.bank_no}`
          }
        },
        {
          title: '状态',
          width: 100,
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' }
        },
        {
          title: '说明',
          width: 100,
          dataIndex: 'remark',
          scopedSlots: { customRender: 'remark' }
        },
        {
          title: '支付凭据',
          width: 100,
          dataIndex: 'pay_order_url',
          scopedSlots: { customRender: 'payorderpic' }
        },
        {
          title: '提交时间',
          width: 180,
          dataIndex: 'created_at'
        }
      ]
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    handlePreview(imageURL) {
      this.previewImage = imageURL
      this.previewVisible = true
    },

    submitSearch(search) {
      // 赋值搜索条件，保留 per_page
      this.query = Object.assign({},
        this.$options.data().query,
        { per_page: this.query.per_page },
        search)
      this.fetchData()
    },

    fetchData() {
      this.loading = true
      findAgentWithdrawals(Object.assign({ agent_id: this.agentId }, this.query)).then((res) => {
        if (res.code === 0) {
          this.data = res.data
          this.pagination = res.pagination
        }
        this.loading = false
      })
    },

    exportData() {
      exportAgentWithdrawals(Object.assign({ agent_id: this.agentId }, this.query)).then((res) => {
        if (res.code === 0 && res.data.is_direct_download === true) {
          exportExcel(res.data.id, res.data.file_name)
        }
      })
    }
  }
}
</script>

<style>
    .status-reject {
      background-color: #e64340;
      color: #fff;
    }

    .status-paid {
      background-color: #42b983;
      color: #fff;
    }

    .status-unpaid {
      background-color: #57a1e6;
      color: #fff;
    }

    .remark-reject {
      color: #e64340;
    }

    .remark-paid {
      color: #42b983;
    }

    .remark-unpaid {
      color: #57a1e6;
    }
</style>
